function hasAccess(roles, access) {
    if (access === undefined || roles === undefined) {
        return true;
    }
    if (roles.some((role) => access.includes(role?.id))) {
        return true;
    }
    return false;
}

module.exports = hasAccess;